import { render, staticRenderFns } from "./LetrexList.vue?vue&type=template&id=7c5f0bbb"
import script from "./LetrexList.vue?vue&type=script&lang=js"
export * from "./LetrexList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports